export default {
  title: 'Notifications',
  empty: {
    title: 'Une évaluation à venir ?',
    description: 'Révise avec un quiz',
    parent: {
      title: 'Pas de notification pour le moment',
      description:
        "Les notifications sur l'activité de vos enfants apparaîtront ici",
    },
  },
  quiz_ready: {
    title: 'Ta révision est prête !',
    button: 'Démarrer',
  },
  challenge_finished: {
    win: 'Tu as gagné ton duel contre {{opponentFirstName}} !',
    lose: 'Tu as perdu ton duel contre {{opponentFirstName}}...',
    equal: 'Egalité contre {{opponentFirstName}}...',
  },
  referral_reward: {
    title: '{{firstName}} a rejoint Baobab +50 XP',
  },
};
